var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDollar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.125H6.25v-5h.625a2.508 2.508 0 012.5 2.5.625.625 0 001.25 0 3.75 3.75 0 00-3.75-3.75H6.25V.625a.625.625 0 00-1.25 0v1.25h-.938a3.75 3.75 0 000 7.5H5v5H3.75a2.508 2.508 0 01-2.5-2.5.625.625 0 10-1.25 0 3.75 3.75 0 003.75 3.75H5v1.25a.625.625 0 101.25 0v-1.25H7.5a3.75 3.75 0 000-7.5zm-2.5 0h-.938a2.5 2.5 0 110-5H5v5zm2.5 6.25H6.25v-5H7.5a2.5 2.5 0 010 5z",
    fill: "#fff"
  })));
}

export default SvgDollar;